import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {ComponentValidation} from "../../models/component-validation";
import Helpers from "../../utils/helpers";

@Injectable()
export class ComponentValidationControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getById(id: string): Observable<ComponentValidation> {
    return this.http.get(this.baseUrl + "componentvalidation/" + id) as Observable<ComponentValidation>;
  }

  public get(serviceId: string, key: string): Observable<ComponentValidation> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/componentvalidation/" + key) as Observable<ComponentValidation>;
  }

  public saveById(id: string, dynamicValidation: ComponentValidation): Observable<ComponentValidation> {
    Helpers.trimRecursiveObj(dynamicValidation);
    const body = JSON.stringify(dynamicValidation);
    return this.http.put(this.baseUrl + "componentvalidation/" + id, body) as Observable<ComponentValidation>;
  }

  public save(serviceId: string, key: string, dynamicValidation: ComponentValidation): Observable<ComponentValidation> {
    Helpers.trimRecursiveObj(dynamicValidation);
    const body = JSON.stringify(dynamicValidation);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/componentvalidation/" + key, body) as Observable<ComponentValidation>;
  }

}
